function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Vehicles",
  d: "M10.131,11.167H6.648a2.347,2.347,0,0,1-4.535,0H.587a.587.587,0,1,1,0-1.173H2.1a2.347,2.347,0,0,1,4.555,0h3.463a2.347,2.347,0,0,1,4.555,0h1.106V6.967l-.854-1.1H10.365a.587.587,0,0,1-.587-.587V1.173H.587A.587.587,0,1,1,.587,0h9.778a.587.587,0,0,1,.587.587v.587h2.5a.587.587,0,0,1,.524.323L15.739,5h0l1.094,1.409a.588.588,0,0,1,.123.36V10.58a.587.587,0,0,1-.587.587h-1.7a2.347,2.347,0,0,1-4.535,0Zm1.094-.606A1.173,1.173,0,1,0,12.4,9.387,1.175,1.175,0,0,0,11.225,10.56Zm-8.018,0A1.173,1.173,0,1,0,4.381,9.387,1.175,1.175,0,0,0,3.207,10.56Zm7.744-5.867h3.321l-1.18-2.347H10.951Z",
  fill: "#fff"
});

var SvgVehicle = function SvgVehicle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.955,
    height: 12.907,
    viewBox: "0 0 16.955 12.907",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle.09b5ffee.svg";
export { ForwardRef as ReactComponent };